<template>
  <div class="upload-video-choose">
    <!-- 视频上传方式 -->
    <iModal
      :styles="{top: '80px'}"
      width="800px"
      @on-visible-change="chooseClose"
      :value="showed"
      :z-index="1100"
      class="uploadVideo"
    >
      <div slot="header" class="upload-video-choose-header">
        <Tabs value="0" :animated="false" @on-click="selectUploadType">
          <TabPane label="Video Material" name="0">
            <div class="upload-video-choose-content">
              <Row :gutter="16" style="height:528px;padding:0 10px;">
                <Col
                  span="12"
                  v-for="(item,index) in list"
                  :key="index"
                  @click.native="selected(index,item)"
                  style="cursor:pointer;margin-bottom:10px;position:relative;"
                >
                  <div class="select">
                    <div class="select-videobox">
                      <img v-if="item.src" :src="item.src" :alt="item.name" />
                      <video v-else :src="item.path"></video>
                    </div>
                    <div class="select-textbox">
                      <span style="width:80%;">{{item.name}}</span>
                      <!-- <span style="text-align:right;">时长</span>
                      <span style="width:80%;">时间</span>
                      <span style="text-align:right;">大小</span> -->
                    </div>
                    <div :class="item.selected?item.selected: 'selected1'">
                      <i
                        class="icon iconfont icon-iconfontcheck"
                        style="position:absolute;left:50%;top:50%;font-size:50px;color:#fff;margin-left:-25px;margin-top:-37.5px;"
                      ></i>
                    </div>
                  </div>
                </Col>
              </Row>
              <div class="my-page" v-if="totalCount > pageSize">
                  <Page
                    show-total
                    show-elevator
                    :page-size="pageSize"
                    :current="pageIndex"
                    :total="totalCount"
                    @on-change="changePage"
                    @on-page-size-change="changePageSize"
                  />
                </div>
            </div>
          </TabPane>
          <TabPane label="Local upload" name="1">
            <div class="my-modal">
              <div class="my-modal-content">
                <Form :label-width="120" :rules="ruleInline" :model="formInline">
                  <FormItem label="Local video：" :required="true">
                    <div
                      class="my-upload-list"
                      v-for="(item, index) in uploadList"
                      :key="'upload' + index"
                      style="width: 150px;height:100px;position: relative;"
                    >
                      <template v-if="item.status === 'finished'">
                        <!-- <img :src="videoImg" style="width: 150px;height:100px;" /> -->
                        <video v-if="item.url" :src="item.url" style="width: 100px;height:100px;"></video>
                        <div class="my-upload-list-cover">
                          <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                          <Icon
                            type="ios-trash-outline"
                            @click.native.stop.prevent="handleRemoveByArr(item)"
                          ></Icon>
                        </div>
                      </template>
                    </div>
                    <Upload
                      ref="upload"
                      :show-upload-list="false"
                      :on-success="handleSuccess"
                      :format="['mp4']"
                      :max-size="51200"
                      :headers="formHeaders"
                      :on-format-error="handleFormatError"
                      :on-error="handleUploadError"
                      :on-exceeded-size="handleMaxSize"
                      :before-upload="handleBeforeUpload"
                      :on-progress="handleUploading"
                      :action="uploadVideoUrl"
                      type="drag"
                      style="display: inline-block;width:100px;height:100px;margin-bottom:10px;"
                      v-show="uploadList && uploadList.length < 1"
                    >
                      <div style="width:100px;height:100px;padding-top: 15px;">
                        <div style="font-size:20px">
                          +
                          <p style="font-size:14px;font-weight:normal;color:#515a6e;">Upload</p>
                        </div>
                      </div>
                    </Upload>
                    <div class="uploading" v-if="uploading">
                      <Spin>
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </div>
                    <p class="upload-p" style="font-size:12px;font-weight:normal;color:#515a6e;">(Requirement: within 50M, suggested length is 9-30s, image scale is 16:9)</p>
                  </FormItem>
                  <FormItem label="Name：" prop="name">
                    <Input v-model="formInline.name" placeholder="Please enter video name, less than 20 letters" style="width: 300px;"/>
                  </FormItem>
                  <!-- <FormItem label="封面：">
                    <RadioGroup v-model="formInline.cover">
                      <Radio size="large" label="0">截取</Radio>
                      <Radio size="large" label="1">自定义</Radio>
                    </RadioGroup>
                  </FormItem> -->
                  <div style="margin-top: 20px;">
                    <div v-if="formInline.cover == 0">
                      <FormItem label="截取帧：">
                        <RadioGroup v-model="picture" type="button" @on-change="pictureChange">
                          <Radio label="5秒"></Radio>
                          <Radio label="10秒"></Radio>
                          <Radio label="15秒"></Radio>
                          <Radio label="20秒"></Radio>
                          <Radio label="25秒"></Radio>
                        </RadioGroup>
                      </FormItem>
                      <FormItem label="预览：">
                        <div class="preview-box">
                          <img :src="this.coverImg" v-if="coverImg" style="width: 100px;height:100px;" />
                          <img src="@/assets/img/empty.png" v-else style="width: 100px;height:100px;" />
                        </div>
                      </FormItem>
                    </div>

                    <FormItem v-if="formInline.cover == 1" label="Cover：">
                      <div
                        class="my-upload-list"
                        v-for="(item, index) in uploadList2"
                        :key="'upload' + index"
                        style="width: 150px;height:100px;"
                      >
                        <template v-if="item.status === 'finished'">
                          <img :src="item.url" style="width: 150px;height:100px;" />
                          <div class="my-upload-list-cover">
                            <Icon
                              type="ios-trash-outline"
                              @click.native.stop.prevent="handleRemoveByArr2(item)"
                            ></Icon>
                          </div>
                        </template>
                        <template v-else>
                          <Spin v-if="item.showProgress" style="width: 150px;height:100px;">
                            <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                          </Spin>
                        </template>
                      </div>
                      <Upload
                        ref="upload2"
                        :show-upload-list="false"
                        :on-success="handleSuccess2"
                        :format="['jpg','jpeg','png']"
                        :max-size="2048"
                        :headers="formHeaders"
                        :on-format-error="handleFormatError2"
                        :on-exceeded-size="handleMaxSize2"
                        :before-upload="handleBeforeUpload2"
                        type="drag"
                        :action="uploadUrl"
                        multiple
                        style="display: inline-block;width:100px;height:100px;margin-bottom:10px;"
                        v-show="uploadList2 && uploadList2.length < 1"
                      >
                        <div style="width:100px;height:100px;padding-top: 15px;">
                          <div style="font-size:20px">
                            +
                            <p style="font-size:14px;font-weight:normal;color:#515a6e;">Upload</p>
                          </div>
                        </div>
                      </Upload>
                      <p style="font-size: 12px;;font-weight:normal;color:#515a6e;">(Requirements: .jpg/png within 2M, suggested size is 750*500px)</p>
                    </FormItem>
                  </div>
                </Form>
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>

      <div slot="footer">
        <Button type="primary" @click="materialClose()">Confirm</Button>
        <Button @click="chooseClose()">Cancel</Button>
      </div>
    </iModal>

    <!-- 查看已上传视频 -->
    <iModal cancel-text v-model="visible" class-name="vertical-center-modal" :footer-hide="false" :z-index="1200">
      <div style="text-align: center;">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
        ></video-player>
      </div>
    </iModal>
  </div>
</template>

<script>
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import { mapGetters, mapActions } from "vuex";
import { videoPlayer } from "vue-video-player";

export default {
  model: {
    prop: "showed",
    event: "change"
  },
  props: {
    showed: Boolean,
    maxCount: Number
  },
  data() {
    return {
      uploadType: 0, // 0：素材库;1：本地
      // 素材库
      list: [],
      selectList: [],
      pageSize: 8,
      pageIndex: 1,
      totalCount: 0,

      // 本地上传
      uploadList: [],
      uploadList2: [],
      coverImg: "",
      videoData: null,
      visible: false,
      uploading: false,
      formInline: {
        cover: "1",
        name: ""
      },
      picture: "5秒", // 视频封面的帧数
      // 效验规则
      ruleInline: {
        name: [
          { required: true, message: "Video name cannot be blank", trigger: "blur" },
          {
            type: "string",
            max: 20,
            message: "视频名称不能大于20位",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      videoMaterial: "materialModule/getVideoMaterial",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders"
    }),
    query() {
      return {
        CompId: this.company.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      };
    },
    // videoImg() {
    //   let url = "";
    //   if (this.uploadList && this.uploadList.length) {
    //     let suffix =
    //       "?x-oss-process=video/snapshot,t_2000,f_jpg,w_590,h_332,m_fast";
    //     url = this.uploadList[0].url + suffix;
    //   }
    //   return url;
    // },
    playerOptions() {
      let res = {};
      if (this.videoData) {
        res = {
          autoplay: false,
          muted: false,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          aspectRatio: "16:9",
          fluid: true,
          sources: [
            {
              type: "video/mp4",
              src: this.videoData.url
            }
          ],
          // poster: this.videoImg,
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试"
        };
      }
      return res;
    },
    showHome() {
      let bool = true;
      if (this.$route.path.indexOf("/host/index") !== -1) {
        bool = false;
      }
      if (this.$route.path.indexOf("/host/project") !== -1) {
        bool = false;
      }
      return bool;
    },
  },
  components: {
    videoPlayer
  },
  methods: {
    ...mapActions("materialModule", ["getvideoMaterial"]),
    selectUploadType(name) {
      if(name === "0") {
        this.uploadType = 0;
      }
      if(name === "1") {
        this.uploadType = 1;
      }
    },

    // 素材库
    chooseClose(e) {
      this.$emit("change", e);
      this.materialShowed();
    },
    materialClose() {
      if(this.uploadType === 0) {
        this.$emit("upload:material", this.selectList);
        this.chooseClose();
        return;
      }
      if(this.uploadType === 1) {
        if (!(this.uploadList && this.uploadList.length)) {
          this.$Message.error(`Please Upload Video`);
          return;
        }
        let videoList = this.transfromImgList(this.uploadList);
        let cover = "0";
        if (this.formInline.cover === "1") {
          cover = "1";
          if (this.uploadList2.length > 0) {
            this.coverImg = this.uploadList2[0].url;
          } 
          // else {
          //   this.$Message.error(`Upload video cover`);
          //   return;
          // }
        }
        let VideoInfo = [{
          Cover: cover,
          Time: "2000",
          Img: this.coverImg,
          Link: String(videoList)
        }]
        this.$emit("upload:material", VideoInfo);
        this.chooseClose();
      }
    },
    setItem(item) {
      let info = JSON.parse(item.videoInfo);
      return {
        name: item.name,
        src: info.Img,
        path: info.Link
      };
    },
    setList(x) {
      let items = x.items;
      this.list = [];
      for (const item of items) {
        let temp = this.setItem(item);
        if (this.selectList.indexOf(temp.path) > -1) {
          temp.selected = "selected2";
        }
        this.list.push(temp);
      }
      this.totalCount = x.totalCount;
      this.pageSize = x.pageSize;
      this.pageIndex = x.pageIndex;
    },
    refushList() {
      if (this.showHome) {
        this.getvideoMaterial(this.query).then(x => {
          this.setList(x);
        });
      }
    },
    materialShowed() {
      this.selectList = [];
      this.uploadList = [];
      this.uploadList2 = [];
      this.$refs.upload.fileList = [];
      this.formInline.name = "";
      this.formInline.cover = "1";
      this.picture = "5秒";
      this.coverImg = "";
      this.refushList();
    },
    selected(i, item) {
      if (item.selected) {
        delete item.selected;
        this.selectList.splice(this.selectList.indexOf(item.path), 1);
      } else if (this.selectList.length < this.maxCount) {
        item.selected = "selected2";
        // this.selectList.push(item.path);
        this.selectList.push(item);
      } else {
        this.$Notice.warning({
          title: "文件数量是超过限制",
          desc: `当前可上传文件最大数量为:${this.maxCount}`
        });
      }
      this.$set(this.list, i, item);
    },
    changePage(e) {
      this.pageIndex = e;
      this.refushList();
    },
    changePageSize(e) {
      this.pageSize = e;
    },
    
    // 本地上传
    handleView(item) {
      this.videoData = item;
      this.visible = true;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      this.uploading = false;
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        // this.coverImg =
        //   this.uploadList[0].url +
        //   `?x-oss-process=video/snapshot,t_${5000},f_jpg,w_590,h_332,m_fast`;
        this.formInline.name = this.uploadList[0].name;
      }
      
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`Incorrect file format, Upload video in mp4 format`);
      this.uploading = false;
    },
    handleFormatError2(file) {
      this.$Message.warning(`Incorrect file format, Upload image in jpg/png format`);
    },
    handleUploadError(file) {
      this.$Message.warning({
        content: "您的网络请求已超时,请重新上传",
        duration: 3,
        closable: true
      });
      this.uploading = false;
    },
    handleMaxSize(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload video size less than 50M`);
    },
    handleMaxSize2(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload image size less than 2M`);
    },
    handleBeforeUpload() {
      this.uploading = true;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`一次只能上传${limitNum}条视频`);
      }
      return check;
    },
    handleBeforeUpload2() {
      const check = this.$refs.upload2.fileList.length < 1;
      if (!check) {
        this.$Message.warning(`最多只能上传1张封面`);
      }
      return check;
    },
    handleUploading(event) {},
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
    pictureChange(e) {
      let second = this.getIntArr(e);
      if (this.uploadList[0] && this.uploadList[0].url) {
        this.coverImg =
          this.uploadList[0].url +
          `?x-oss-process=video/snapshot,t_${second[0] *
            1000},f_jpg,w_590,h_332,m_fast`;
      }
    },
    getIntArr(str) {
      return str
        .replace(/[^0-9]/gi, " ")
        .trim()
        .split(/\s+/);
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
  },
  mounted() {
    this.materialShowed();
  }
};
</script>

<style lang="scss" scoped>
.select {
  width: 100%;
  height: 120px;
  display: inline-block;
  position: relative;
  &-videobox {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 100px;
    max-height: 100%;
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      max-width: 100px;
      max-height: 100px;
      margin: auto;
    }
    video {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      max-width: 100px;
      max-height: 100px;
      margin: auto;
    }
  }
  &-textbox {
    position: absolute;
    top: 0;
    left: 110px;
    right: 20px;
    bottom: 0;
    padding: 20px 0;
    max-width: 100%;
    max-height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    span {
      word-break: break-all;
    }
  }
  .selected1 {
    width: 100%;
    height: 80%;
    top: 0;
    right: 0;
    position: absolute;
    background-color: rgba(145, 145, 146, 0);
    i {
      opacity: 0;
    }
  }
  .selected2 {
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    position: absolute;
    background-color: rgba(145, 145, 146, 0.6);
    i {
      opacity: 1;
    }
  }
}
.my-page {
  height: 50px;
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.video-player {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}
.my-upload-list-cover {
  i {
    position: relative !important;
    top: -2px !important;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.preview-box {
  width: 100px;
  height: 100px;
  background-color: #bfbfbf;
  border-radius: 5px;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="scss">
.uploadVideo {
  .ivu-modal-header {
    border-bottom: none;
  }
}
.ivu-message {
  z-index: 2000 !important;
}
.ivu-notice {
  z-index: 2000 !important;
}
</style>